import { get,getfile,getAt,postAt,DELETEAt } from '@/utils/http'
var apI = '/api/v1'
//附件记录删除
var deleteAttachmentPre = $config.deleteAttachmentPre? $config.deleteAttachmentPre : 'Attachment/'
var deleteAttachmentSuffix = $config.deleteAttachmentSuffix? $config.deleteAttachmentSuffix : ''
export const deleteAttachment = (data) => DELETEAt(apI + deleteAttachmentPre+ data+deleteAttachmentSuffix)
//附件记录查询
var attachmentListUrl = $config.attachmentListUrl? $config.attachmentListUrl : '/Attachment/list'
export const getAttachmentList = (data) => getAt(apI+ attachmentListUrl,data)
//附件记录保存
var saveAttachmentUrl = $config.saveAttachment? $config.saveAttachment : '/Attachment/save'
export const saveAttachment = (data) => postAt(apI + saveAttachmentUrl,data)
//服务器文件删除
var deleteUploadFileUrl = $config.deleteUploadFileUrl? $config.deleteUploadFileUrl : '/api/file/delete'
export const deleteUploadFile = (data) => getfile(deleteUploadFileUrl, data)



// WEBPACK FOOTER //
// ./src/api/gate/attach/index.js